import React from "react";

function LoginFaq() {
  return (
    <div>
      <section className="w-100 float-left faq-con faq-page-con pt-5">
        <div className="wrapper2">
          <div className="generic-title text-center">
            <h2 data-aos="fade-up" data-aos-duration={600}>
              FAQs
            </h2>
          </div>
          <div className="faq-box">
            <div className="faq-content">
              <div id="accordion">
                {/* FAQ 1 */}
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="headingOne">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Q1: What is DNET?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      DNET is a decentralized finance (DeFi) platform built on
                      the Arbitrum blockchain, offering a secure, scalable, and
                      efficient ecosystem for digital asset management.
                    </div>
                  </div>
                </div>
                {/* FAQ 2 */}
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="headingTwo">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Q2: What is NYO Protocol?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapseTwo"
                    className="collapse"
                    aria-labelledby="headingTwo"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      NYO stands for Neuro, Yield, Optimization, a system
                      designed to maximize financial growth through AI-driven
                      analytics and blockchain automation. It enables users to
                      earn daily yields and multi-tier rewards through DNET’s
                      affiliate program.
                    </div>
                  </div>
                </div>
                {/* FAQ 3 to 13 */}
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="headingThree">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Q3: How does the DNET Affiliate work?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapseThree"
                    className="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      DNET allows users to Create NYO and earn daily yields.
                      Additionally, users can generate multi-tier rewards by
                      referring others. The more active referrals, the higher
                      the earning potential.
                    </div>
                  </div>
                </div>
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="headingFour">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Q4: What is the Daily Yield?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapseFour"
                    className="collapse"
                    aria-labelledby="headingFour"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Daily Yield is the automated earnings users receive based
                      on their Created NYO amount.
                    </div>
                  </div>
                </div>
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="heading5">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse5"
                        aria-expanded="false"
                        aria-controls="collapse5"
                      >
                        Q5: How do Multi-Yield Tiers work?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse5"
                    className="collapse"
                    aria-labelledby="heading5"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      DNET’s affiliate plan includes Multi-Yield Tiers, allowing
                      users to earn additional rewards from referrals. Rewards
                      are distributed across different tiers based on
                      participation and referral activity.
                    </div>
                  </div>
                </div>
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="heading6">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse6"
                        aria-expanded="false"
                        aria-controls="collapse6"
                      >
                        Q6: What is “Create NYO”?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse6"
                    className="collapse"
                    aria-labelledby="heading6"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      “Create NYO” is the process where users allocate funds (in
                      DNET or USDT) to activate their yield generation. Instead
                      of traditional investment terms, this mechanism provides
                      automated and structured rewards based on contribution.
                    </div>
                  </div>
                </div>
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="heading7">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse7"
                        aria-expanded="false"
                        aria-controls="collapse7"
                      >
                        Q7: What is the minimum and maximum amount to Create
                        NYO?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse7"
                    className="collapse"
                    aria-labelledby="heading7"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Users can Create NYO with a minimum $20 and maximum $1000
                      limit, ensuring flexible participation.
                    </div>
                  </div>
                </div>
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="heading8">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse8"
                        aria-expanded="false"
                        aria-controls="collapse8"
                      >
                        Q8: What currencies can I use to Create NYO?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse8"
                    className="collapse"
                    aria-labelledby="heading8"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      You can use DNET tokens or USDT (ARB) to Create NYO.
                    </div>
                  </div>
                </div>
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="heading9">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse9"
                        aria-expanded="false"
                        aria-controls="collapse9"
                      >
                        Q9: What happens if I Create NYO using USDT only?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse9"
                    className="collapse"
                    aria-labelledby="heading9"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      If you Create NYO 100% with USDT, you will be able to
                      Claim your multi-tier rewards in USDT.
                    </div>
                  </div>
                </div>
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="heading10">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse10"
                        aria-expanded="false"
                        aria-controls="collapse10"
                      >
                        10 : What happens if I Create NYO using both USDT and
                        DNET?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse10"
                    className="collapse"
                    aria-labelledby="heading10"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      If you use both USDT and DNET, your multi-tier and NYO
                      rewards will be Claimed only in DNET tokens.
                    </div>
                  </div>
                </div>
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="heading11">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse11"
                        aria-expanded="false"
                        aria-controls="collapse11"
                      >
                        Q11: What is the minimum amount I can Claim?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse11"
                    className="collapse"
                    aria-labelledby="heading11"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      <b> For Daily Yield</b> : Users must have at least $20 NYO
                      to Claim.
                      <br />
                      <b>For Multi-Yield Tiers</b>: Minimum Claiming starts at
                      $5.
                    </div>
                  </div>
                </div>
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="heading12">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse12"
                        aria-expanded="false"
                        aria-controls="collapse12"
                      >
                        Q12: Are there any other claiming charges?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse12"
                    className="collapse"
                    aria-labelledby="heading12"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Yes, a <b> DNET Fees of 5% </b>applies when you Claim your
                      NYO rewards.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LoginFaq;
